import { Message } from '@messageformat/react';
import { bulletColors } from '../DiversityAnalyzer/utils';
import ColorBulletListItem from '../../ColorBulletListItem';

interface Data {
  label: string;
  value: number;
  type?: string;
}

interface Props {
  data: Data[];
}

const ProductTypeList = (props: Props): JSX.Element => {
  const { data } = props;
  const filteredData = data.filter((valuex) => valuex.value > 0);
  if (filteredData.length === 0) {
    return (
      <p className="opds-styles-v1-text-body-small">
        <Message id="course7.emptyportfolio" />
      </p>
    );
  }

  return (
    <ul style={{ margin: 0 }}>
      {filteredData.map((valuex, idx) => (
        <ColorBulletListItem
          key={valuex.label}
          color={bulletColors[idx]}
          className="opds-styles-v1-text-body-small"
        >
          <Message id={valuex.label} /> {valuex.value}%
        </ColorBulletListItem>
      ))}
    </ul>
  );
};

export default ProductTypeList;
